import axios from "axios";
import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { loginActions } from "../../../store/login-slice";
import { sidebarActions } from "../../../store/sidebar-slice";
import { userActions } from "../../../store/user-slice";
import { stepsActions } from "../../../store/steps-slice";

export default function InstamojoOAuth2Callback() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const params = useMemo(() => {
    const url = new URL(window.location);
    return {
      code: url.searchParams.get("code"),
      state: url.searchParams.get("state"),
    };
  }, [window.location]);

  const logoutHandler = () => {
    dispatch(loginActions.setToken(null));
    dispatch(loginActions.setIsLogin(false));
  };

  useEffect(() => {
    if (!params.code || !params.state) return navigate("/auth/login", { replace: true });

    dispatch(sidebarActions.setSidebar(false));

    axios
      .post("https://x.zocket.com/prod/customer/auth/api/v1/instamojo/callback", {
        auth_token: params.code,
      })
      .then((response) => {
        if (!response.data.data.user) {
          alert("Authentication failed. User doesn't exist");
          navigate("/auth/login");
          return;
        }
        localStorage.setItem("auth", JSON.stringify(response.data.data));
        setTimeout(logoutHandler, response.data.data.expires_in);
        dispatch(loginActions.setIsLogin(true));
        dispatch(loginActions.setToken(response.data.data.access_token));
        dispatch(stepsActions.selectedCategory(response.data.data.user.business_category));
        dispatch(userActions.updateUser({ user: response.data.data.user, username: response.data.data.username }));
        dispatch(sidebarActions.setSidebar(true));
        dispatch(sidebarActions.setRoute("/"));
        if (response.data.data.is_password_created) {
          navigate("/", { replace: true });
        } else {
          navigate("/auth/password/set", { replace: true });
        }
      })
      .catch((error) => {
        if (error.response) {
          // alert(error.response.data.message);
          return navigate("/auth/login");
        } else {
          // alert(error.message);
          return navigate("/auth/login");
        }
      });
  }, [params]);

  return null;
}
